var map = {
	"./mobile/buy.vue": [
		"a8ba",
		"chunk-3e1b9214",
		"chunk-11dfc402",
		"chunk-cfb1e316"
	],
	"./pc/buy.vue": [
		"2deb",
		"chunk-3e1b9214",
		"chunk-11dfc402",
		"chunk-10bbf416"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "8e20";
module.exports = webpackAsyncContext;